export default function BackgroundOrbs() {
    return (
        <div
            aria-hidden
            className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
        >
            <div
                className="animate-orb absolute -top-32 -left-32 h-[560px] w-[560px] rounded-full opacity-40 blur-[120px]"
                style={{
                    background:
                        "radial-gradient(circle, rgba(212,175,55,0.55), transparent 60%)",
                }}
            />
            <div
                className="animate-orb absolute -bottom-40 right-[-10%] h-[640px] w-[640px] rounded-full opacity-30 blur-[140px]"
                style={{
                    background:
                        "radial-gradient(circle, rgba(37,99,235,0.55), transparent 60%)",
                    animationDelay: "4s",
                }}
            />
            <div
                className="absolute inset-0 opacity-[0.08]"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)",
                    backgroundSize: "60px 60px",
                    maskImage:
                        "radial-gradient(ellipse at center, black 30%, transparent 80%)",
                }}
            />
        </div>
    );
}
